import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=239c02f8&scoped=true"
import script from "./Paginate.vue?vue&type=script&lang=js"
export * from "./Paginate.vue?vue&type=script&lang=js"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=239c02f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c02f8",
  null
  
)

export default component.exports